import { useTranslation } from "react-i18next";
import SkeletonBlock from "../common/SkeletonBlock";
import RecordingModeTiles from "../recording/RecordingModeTiles";
import { ALL_MODES } from "../../utils/recordingModes";

const LOADING_BUTTON_WIDTHS = ["w-24", "w-32"];

export function MeasurePanel({
  onClose,
  firstRunByVariant,
  loadingModes = false,
  isPermitted = () => false,
}) {
  const { t } = useTranslation("common");
  const showRecordings = ALL_MODES.some((mode) => isPermitted(mode));

  return (
    <div className="flex w-full max-w-lg flex-col gap-4 md:pt-4">
      <div className="flex w-full min-h-[44px] items-center justify-between gap-3">
        <h2 className="subtitle-text">{t("navBar.measure", "Measure")}</h2>
        <button
          type="button"
          className="small-outlined-button !min-h-0 !inline-flex !min-w-fit !flex-row !items-center !justify-center !gap-1 whitespace-nowrap group"
          onClick={onClose}
          aria-label={t("close", "Close")}
        >
          <span
            className="material-symbols-outlined text-[24px] text-primary hover:!text-greyscale-1 group-hover:text-greyscale-1"
            aria-hidden="true"
          >
            close
          </span>
          <span className="leading-none">{t("close", "Close")}</span>
        </button>
      </div>

      {loadingModes ? (
        <section
          className="flex w-full flex-col gap-3"
          data-testid="measure-panel-loading"
        >
          {LOADING_BUTTON_WIDTHS.map((width, index) => (
            <div
              key={index}
              aria-hidden="true"
              data-testid="measure-panel-loading-button"
              className="primary-button pointer-events-none !relative !min-h-16 w-full"
            >
              <SkeletonBlock
                tone="light"
                className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 rounded-full"
              />
              <div className="w-full px-9">
                <SkeletonBlock
                  tone="light"
                  className={`mx-auto h-5 rounded-full ${width}`}
                />
              </div>
            </div>
          ))}
        </section>
      ) : showRecordings ? (
        <section className="flex w-full flex-col gap-3">
          <RecordingModeTiles
            firstRunByVariant={firstRunByVariant}
            isPermitted={isPermitted}
          />
        </section>
      ) : null}
    </div>
  );
}
